// This class contains all the logic for managing location information

export default class UserLocation {
    constructor(object) {
        this._typeof = 'location'

        if (object) {
            this._address = object.address
            this._country = object.country
            this._houseNumber = object.houseNumber
            this._state = object.state
            this._streetName = object.streetName
            this._zipCode = object.zipCode
        }

        this._geolocation = navigator.geolocation.getCurrentPosition((position) => {return position}, (error) => {return error})

    }

    // getters

    get address() {
        return this._address
    }

    get country() {
        return this._country
    }

    get houseNumber() {
        return this._houseNumber
    }

    get state() {
        return this._state
    }

    get streetName() {
        return this._streetName
    }

    get zipCode() {
        return this._zipCode
    }

    get geolocation() {
        return this._geolocation
    }

    get typeof() {
        return this._typeof
    }

    // setters

    /**
     * @param {String} newAddress
     */
    set setAddress(newAddress) {
        this._address = newAddress
    }

    /**
     * @param {String} countryName
     */
    set setCountry(countryName) {
        this._country = countryName
    }

    /**
     * @param {String} number
     */
    set setHouseNumber(number) {
        this._houseNumber = number
    }

    /**
     * @param {String} stateName
     */
    set setState(stateName) {
        this._state = stateName
    }

    /**
     * @param {String} streetName
     */
    set setStreetName(streetName) {
        this._streetName = streetName
    }

    /**
     * @param {Number} newZipCode
     */
    set setZipCode(newZipCode) {
        this._zipCode = newZipCode
    }

    /**
     * @param {Number} newLocation
     */
    set setGeolocation(newLocation) {
        this._geolocation = newLocation
    }
}
